import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Loader from '../../components/Loader/Loader';

export default function CategoryRedirectionMiddleware() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [pathToNavigate, setPathToNavigate] = useState(null);

  const searchParamsArr = [];
  const brands = [];

  const categoryRoutes = [
    {
      id: '...',
      path: '/vehicules-accidentes',
      newPath: 'vehicules-accidentes',
    },
    {
      id: '171',
      path: '/vehicules-d-occasion',
      newPath: 'vehicules-d-occasion',
    },
    { id: '106', path: '/pieces-auto-d-occasion', newPath: 'pieces' },
    { id: '126', path: '/roues', newPath: 'jantes' },
    { id: '185', path: '/jantes-d-occasion', newPath: 'jantes' },
    { id: '182', path: '/pneus-d-occasion', newPath: 'pneus' },
  ];

  const categoryMatch = location.pathname.match(
    /^\/catalog\/category\/view(?:\/s\/([^\/]+))?(?:\/(?!id\/)[^\/]*)*(?:\/id\/([^\/]+))?/,
  );

  const categorySlug = categoryMatch?.[1] || null;
  const categoryId = categoryMatch?.[2] || null;

  const searchParams =
    location.search
      ?.split('?')[1]
      ?.split('&')
      ?.map((param) => ({
        attribute: decodeURIComponent(param.split('=')[0].split('%5B')[0]), // %5B = [
        value: decodeURIComponent(param.split('=')[1]),
      })) || [];

  const categoryRoute = categoryRoutes.find(
    (route) =>
      route.path === `/${categorySlug}` ||
      route.id === categoryId ||
      route.path ===
        `/${searchParams.find((param) => param.attribute === 's')?.value}`,
  );

  let sortBy = null;
  switch (searchParams.find((param) => param.attribute === 'order')?.value) {
    case 'price':
      sortBy = 'price';
      break;
  }
  if (sortBy) {
    switch (searchParams.find((param) => param.attribute === 'dir')?.value) {
      case 'asc':
        sortBy += ':asc';
        break;
      case 'desc':
      default:
        sortBy += ':desc';
        break;
    }
  }

  brands.push(
    ...Array.from(
      new Set([
        ...searchParams
          .filter((param) => param.attribute === 'rimbrand')
          .map((param) => param.value),
        ...searchParams
          .filter((param) => param.attribute === 'tyrebrand')
          .map((param) => param.value),
        ...searchParams
          .filter((param) => param.attribute === 'marque')
          .map((param) => param.value),
      ]),
    ),
  );

  if (sortBy) searchParamsArr.push({ key: 'sortBy', value: sortBy });

  const searchParamsStr = searchParamsArr
    .map(({ key, value }) => `${key}=${value}`)
    .join('&');

  if (loading) {
    if (categoryRoute) {
      setPathToNavigate(
        `/catalogue/${categoryRoute.newPath}${
          brands.length > 0 ? `/marque-${brands[0]}` : ''
        }${searchParamsStr ? `?${searchParamsStr}` : ''}`,
      );
      setLoading(false);
    } else if (categoryMatch) {
      setPathToNavigate(
        `/catalogue${brands.length > 0 ? `/marque-${brands[0]}` : ''}${
          searchParamsStr ? `?${searchParamsStr}` : ''
        }`,
      );
      setLoading(false);
    } else {
      setPathToNavigate(null);
      setLoading(false);
    }
  }

  // useEffect(() => {
  //   console.log(pathToNavigate);
  // }, [pathToNavigate]);

  return loading ? (
    <Loader />
  ) : pathToNavigate ? (
    <Navigate to={{ pathname: pathToNavigate }} replace />
  ) : (
    <Navigate to={{ pathname: '/catalogue' }} replace />
  );
}
